import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createVNode(_component_router_view)
  ], 32))
}